import { MAT_NATIVE_DATE_FORMATS, MatDateFormats } from '@angular/material/core';

export const PAYEE_NATIVE_DATE_FORMATS: MatDateFormats = {
  ...MAT_NATIVE_DATE_FORMATS,
  display: {
    ...MAT_NATIVE_DATE_FORMATS.display,
    dateInput: { year: 'numeric', month: '2-digit', day: '2-digit' },
    monthYearLabel: { year: 'numeric', month: 'short' },
  },
};
